import React from 'react'

import Badge from '@totallymoney/ui/components/Badge'
import Flex from '@totallymoney/ui/components/Flex'
import ExclusiveOfferBadge from '@totallymoney/ui/productTable/components/ExclusiveOfferBadge'
import { SpacingKeys } from '@totallymoney/ui/theme/Spacing'

import {
    CreditCardProductCategory,
    OfferType,
    ScoredCreditCardProduct,
    ScoredCreditCardProductCategory,
} from '@appTypes/EligibilityApi.interface'

import BestMatchBadge from '@routes/ScoredTableRoute/components/ScoredTable/components/ScoredTableItem/components/BestMatchBadge'
import useGetDifferenceInNewCreditCardsOffers from '@routes/ScoredTableRoute/hooks/useGetDifferenceInNewCreditCardsOffers'

const hasProductCategory = (
    creditCardProductCategories: ScoredCreditCardProductCategory[],
    targetCategory: CreditCardProductCategory
) =>
    creditCardProductCategories.some(
        creditCardProductCategory =>
            creditCardProductCategory.name === targetCategory
    )

const getBadges = (
    scoredCreditCard: ScoredCreditCardProduct,
    isBestMatch: boolean,
    isNewOffer: boolean
) => {
    return [
        isBestMatch && {
            key: 'bestMatch',
            component: <BestMatchBadge />,
        },
        isNewOffer && {
            key: 'newOffer',
            component: <Badge text="New offer" size="medium" />,
        },
        scoredCreditCard.offerType === OfferType.TMExclusive && {
            key: 'exclusiveOffer',
            component: <ExclusiveOfferBadge />,
        },
        hasProductCategory(
            scoredCreditCard.productCategories,
            CreditCardProductCategory.Rewards
        ) && {
            key: 'rewards',
            component: <Badge text="Rewards" size="medium" icon="checkmark" />,
        },
        hasProductCategory(
            scoredCreditCard.productCategories,
            CreditCardProductCategory.Cashback
        ) && {
            key: 'cashback',
            component: <Badge text="Cashback" size="medium" icon="checkmark" />,
        },
    ].filter(Boolean) as {
        component: React.ReactNode
        key:
            | 'exclusiveOffer'
            | 'rewards'
            | 'cashback'
            | 'newOffer'
            | 'bestMatch'
    }[]
}

const BadgesRow = ({
    scoredCard,
    isBestMatch = false,
    mb = 'space30',
}: {
    isBestMatch: boolean
    mb?: SpacingKeys
    scoredCard: ScoredCreditCardProduct
}) => {
    const isNewOffer = useGetDifferenceInNewCreditCardsOffers().includes(
        scoredCard.productCode
    )

    const badges = getBadges(scoredCard, isBestMatch, isNewOffer)

    return badges.length > 0 ? (
        <Flex mb={mb} gridGap="space10" flexWrap="wrap">
            {badges.map(badge => (
                <React.Fragment key={badge.key}>
                    {badge.component}
                </React.Fragment>
            ))}
        </Flex>
    ) : null
}

export default BadgesRow
